export default __webpack_public_path__ + "images/JF.690500c.png";